import { TableRow, TableCell, Tooltip, IconButton, Box } from "@mui/material";
import { Delete, InfoOutlined } from "@mui/icons-material";
import { FC, useState } from "react";
import { InputText } from "src/framework/components/forms/inputs/InputText";
import theme from "src/theme/light";

export type AnexoFile = {
  index?: number;
  descricao?: string;
  file?: File;
  previewName?: string | null;
  progress?: number
}

type UploadFileProperties = {
  anexo: AnexoFile,
  index: number;
  nomesAnexos: string[];
  disabled?: boolean;
  onRemove: (index: number) => void;
  hasError: (error: boolean, index: number) => void;
  onChange: (descricao: string, index: number) => void;

}

const UploadFile: FC<UploadFileProperties> = ({
  anexo,
  nomesAnexos = [],
  index,
  disabled = false,
  onRemove,
  onChange,
  hasError,
}) => {

  const _anexo: AnexoFile = anexo;

  const [error, setError] = useState<boolean>(false)

  const isUnique = (value: string): boolean => {
      let _error: boolean = false;
      for (let n of nomesAnexos) {
          const _nome: string[] = n.split(":")
          if (_nome[0] !== String(anexo.index) && _nome[1] === value) {
              _error = true
          }
      }
      hasError(_error, index)
      return _error;
  }

  return <>
      <TableRow>
          <TableCell>
            <Box display='flex' alignItems={'center'} justifyContent='flex-start'>
                <Tooltip title={String(_anexo.file?.name)}>
                    <span style={{ cursor: "help", marginRight: "7px", marginTop: "6px" }}>
                        <InfoOutlined fontSize="small" />
                    </span>
                </Tooltip>
                <span>{_anexo.previewName}</span>
            </Box>
          </TableCell>
          <TableCell>
              <InputText
                  margin="none"
                  fullWidth
                  value={_anexo?.descricao}
                  error={error}
                  disabled={disabled}
                  onChange={(event: any) => {
                      onChange(event.target.value, index)
                      setError(isUnique(event.target.value))
                  }}
                  onBlur={(event: any) => {
                      setError(isUnique(event.target.value))
                  }}
              />
          </TableCell>
          <TableCell align="right">
              <IconButton size="small" style={{ color: theme.palette.error.main }} onClick={() => onRemove(index)} disabled={disabled}>
                  <Delete />
              </IconButton>
          </TableCell>
      </TableRow>
  </>
}

export { UploadFile }